// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { Anchor, Badge, Button, Card, Center, Checkbox, Container, Group, PasswordInput, Stack, Text, TextInput, Title } from '@/components/ui';
import { IconMail, IconLock, IconArrowLeft, IconCube } from '@tabler/icons-react';
import { FadeIn, SlideIn, HoverScale } from '@/components/animations';
import { ParallaxBackground, SocialLoginButtons } from '../components';

export default function LoginParallax() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  return (
    <ParallaxBackground preset="gradient-orbs" mouseParallax intensity={30}>
      <Center mih="100vh" p="md">
        <Container size="xs" w="100%">
          <SlideIn direction="up" delay={100} duration={600}>
            <Card
              p="xl"
              radius="lg"
              style={{
                backgroundColor: isDark ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(16px)',
                border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
              }}
            >
              <Stack gap="lg">
                {/* Back button */}
                <Button
                  component={Link}
                  to="/demo/auth-pages/login"
                  variant="subtle"
                  size="xs"
                  leftSection={<IconArrowLeft size={14} />}
                  w="fit-content"
                >
                  Back to variants
                </Button>

                {/* Header */}
                <FadeIn delay={200}>
                  <Stack align="center" gap="xs">
                    <Badge
                      leftSection={<IconCube size={12} />}
                      variant="gradient"
                      gradient={{ from: 'violet', to: 'pink' }}
                      size="lg"
                    >
                      Parallax Effect
                    </Badge>
                    <Title order={2} ta="center" mt="md">
                      Immersive Login
                    </Title>
                    <Text c="dimmed" size="sm" ta="center">
                      Experience depth with mouse-responsive parallax
                    </Text>
                  </Stack>
                </FadeIn>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <Stack gap="md">
                    <FadeIn delay={300}>
                      <TextInput
                        label="Email"
                        placeholder="your@email.com"
                        leftSection={<IconMail size={16} />}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        size="md"
                        radius="md"
                      />
                    </FadeIn>

                    <FadeIn delay={400}>
                      <PasswordInput
                        label="Password"
                        placeholder="Your password"
                        leftSection={<IconLock size={16} />}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        size="md"
                        radius="md"
                      />
                    </FadeIn>

                    <FadeIn delay={500}>
                      <Group justify="space-between">
                        <Checkbox
                          label="Remember me"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.currentTarget.checked)}
                        />
                        <Anchor
                          component={Link}
                          to="/demo/auth-pages/forgot-password/parallax"
                          size="sm"
                        >
                          Forgot password?
                        </Anchor>
                      </Group>
                    </FadeIn>

                    <FadeIn delay={600}>
                      <HoverScale scale={1.02}>
                        <Button
                          type="submit"
                          fullWidth
                          size="md"
                          radius="md"
                          variant="gradient"
                          gradient={{ from: 'violet', to: 'pink' }}
                        >
                          Sign in
                        </Button>
                      </HoverScale>
                    </FadeIn>
                  </Stack>
                </form>

                {/* Social Login */}
                <FadeIn delay={700}>
                  <SocialLoginButtons
                    providers={['google', 'github']}
                    layout="horizontal"
                    variant="light"
                  />
                </FadeIn>

                {/* Register Link */}
                <FadeIn delay={800}>
                  <Text ta="center" size="sm">
                    Don't have an account?{' '}
                    <Anchor component={Link} to="/demo/auth-pages/register/parallax" fw={500}>
                      Sign up
                    </Anchor>
                  </Text>
                </FadeIn>
              </Stack>
            </Card>
          </SlideIn>
        </Container>
      </Center>
    </ParallaxBackground>
  );
}
